export const Dashboard = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 8.00001C15.5 8.28408 15.3395 8.54378 15.0854 8.67083L1.58541 15.4208C1.32663 15.5502 1.01649 15.5192 0.78844 15.3412C0.560388 15.1631 0.455095 14.8697 0.51786 14.5873L1.9817 8.00001L0.51786 1.4127C0.455095 1.13026 0.560389 0.836908 0.788441 0.658851C1.01649 0.480794 1.32663 0.449792 1.58541 0.579185L15.0854 7.32919C15.3395 7.45623 15.5 7.71593 15.5 8.00001ZM3.35163 8.75001L2.32396 13.3745L11.5729 8.75001L3.35163 8.75001ZM11.5729 7.25001L2.32396 2.62551L3.35163 7.25001L11.5729 7.25001Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const User = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path
        d="M9 3C7.34315 3 6 4.34315 6 6C6 7.65685 7.34315 9 9 9C10.6569 9 12 7.65685 12 6C12 4.34315 10.6569 3 9 3ZM4.5 6C4.5 3.51472 6.51472 1.5 9 1.5C11.4853 1.5 13.5 3.51472 13.5 6C13.5 8.48528 11.4853 10.5 9 10.5C6.51472 10.5 4.5 8.48528 4.5 6ZM6 13.5C4.75736 13.5 3.75 14.5074 3.75 15.75C3.75 16.1642 3.41421 16.5 3 16.5C2.58579 16.5 2.25 16.1642 2.25 15.75C2.25 13.6789 3.92893 12 6 12H12C14.0711 12 15.75 13.6789 15.75 15.75C15.75 16.1642 15.4142 16.5 15 16.5C14.5858 16.5 14.25 16.1642 14.25 15.75C14.25 14.5074 13.2426 13.5 12 13.5H6Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Notification = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.60961 2.43609C7.83248 1.88712 8.37103 1.5 9 1.5C9.62897 1.5 10.1675 1.88712 10.3904 2.43609C12.6151 3.04554 14.25 5.08185 14.25 7.5V11.0229L15.624 13.084C15.7775 13.3141 15.7918 13.61 15.6613 13.8539C15.5307 14.0978 15.2766 14.25 15 14.25H11.5984C11.4165 15.5221 10.3224 16.5 9 16.5C7.67757 16.5 6.58355 15.5221 6.40158 14.25H3C2.7234 14.25 2.46926 14.0978 2.33875 13.8539C2.20823 13.61 2.22254 13.3141 2.37596 13.084L3.75 11.0229V7.5C3.75 5.08185 5.38487 3.04554 7.60961 2.43609ZM7.93902 14.25C8.09345 14.6869 8.51017 15 9 15C9.48983 15 9.90655 14.6869 10.061 14.25H7.93902ZM9 3.75C6.92893 3.75 5.25 5.42893 5.25 7.5V11.25C5.25 11.3981 5.20617 11.5428 5.12404 11.666L4.40139 12.75H13.5986L12.876 11.666C12.7938 11.5428 12.75 11.3981 12.75 11.25V7.5C12.75 5.42893 11.0711 3.75 9 3.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Reply = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M3.75 2.25C2.92157 2.25 2.25 2.92157 2.25 3.75V14.25C2.25 15.0784 2.92157 15.75 3.75 15.75H8.99927C8.99976 15.75 9.00024 15.75 9.00073 15.75H14.25C15.0784 15.75 15.75 15.0784 15.75 14.25V9.00073C15.75 9.00024 15.75 8.99976 15.75 8.99927V3.75C15.75 2.92157 15.0784 2.25 14.25 2.25H3.75ZM14.25 8.68934L8.68934 14.25H3.75V3.75H14.25V8.68934ZM10.8107 14.25L14.25 10.8107V14.25H10.8107Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Setting = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9 3C8.58579 3 8.25 3.33579 8.25 3.75C8.25 5.01919 6.71549 5.65481 5.81804 4.75735C5.52514 4.46446 5.05027 4.46446 4.75738 4.75735C4.46448 5.05025 4.46448 5.52512 4.75738 5.81801C5.65487 6.7155 5.01917 8.25 3.75 8.25C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75C5.01927 9.75 5.65473 11.2846 4.75733 12.182C4.46444 12.4749 4.46444 12.9498 4.75733 13.2426C5.05022 13.5355 5.5251 13.5355 5.81799 13.2426C6.71543 12.3452 8.25 12.9807 8.25 14.25C8.25 14.6642 8.58579 15 9 15C9.41421 15 9.75 14.6642 9.75 14.25C9.75 12.9808 11.2845 12.3452 12.182 13.2426C12.4749 13.5355 12.9498 13.5355 13.2427 13.2426C13.5356 12.9497 13.5356 12.4749 13.2427 12.182C12.3452 11.2845 12.9808 9.75 14.25 9.75C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25C12.9809 8.25 12.3451 6.71554 13.2426 5.81802C13.5355 5.52513 13.5355 5.05026 13.2426 4.75737C12.9497 4.46447 12.4748 4.46447 12.182 4.75736C11.2845 5.65484 9.75 5.01915 9.75 3.75C9.75 3.33579 9.41421 3 9 3ZM6.75612 3.58277C6.84168 2.41823 7.81361 1.5 9 1.5C10.1864 1.5 11.1583 2.41823 11.2439 3.58277C12.1278 2.81983 13.4644 2.8578 14.3033 3.6967C15.1422 4.53561 15.1802 5.87216 14.4172 6.75612C15.5818 6.84165 16.5 7.81359 16.5 9C16.5 10.1864 15.5818 11.1583 14.4172 11.2439C15.1802 12.1278 15.1422 13.4644 14.3033 14.3033C13.4644 15.1422 12.1278 15.1802 11.2439 14.4172C11.1583 15.5818 10.1864 16.5 9 16.5C7.81359 16.5 6.84166 15.5818 6.75612 14.4172C5.87216 15.1802 4.53559 15.1422 3.69667 14.3033C2.85776 13.4644 2.81979 12.1278 3.58277 11.2439C2.41822 11.1583 1.5 10.1864 1.5 9C1.5 7.81359 2.41825 6.84165 3.58282 6.75612C2.81984 5.87216 2.8578 4.5356 3.69672 3.69669C4.53562 2.85779 5.87216 2.81981 6.75612 3.58277Z"
        fill="currentColor"
      />
      <path
        d="M9 7.5C8.60217 7.5 8.22064 7.65804 7.93934 7.93934C7.65804 8.22064 7.5 8.60217 7.5 9C7.5 9.39783 7.65804 9.77936 7.93934 10.0607C8.22064 10.342 8.60217 10.5 9 10.5C9.39783 10.5 9.77936 10.342 10.0607 10.0607C10.342 9.77936 10.5 9.39783 10.5 9C10.5 8.60217 10.342 8.22064 10.0607 7.93934C9.77936 7.65804 9.39783 7.5 9 7.5ZM6.87868 6.87868C7.44129 6.31607 8.20435 6 9 6C9.79565 6 10.5587 6.31607 11.1213 6.87868C11.6839 7.44129 12 8.20435 12 9C12 9.79565 11.6839 10.5587 11.1213 11.1213C10.5587 11.6839 9.79565 12 9 12C8.20435 12 7.44129 11.6839 6.87868 11.1213C6.31607 10.5587 6 9.79565 6 9C6 8.20435 6.31607 7.44129 6.87868 6.87868Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Logout = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 15C8.25 14.5858 7.91421 14.25 7.5 14.25H3.75V3.75H7.5C7.91421 3.75 8.25 3.41421 8.25 3C8.25 2.58579 7.91421 2.25 7.5 2.25H3.75C2.92157 2.25 2.25 2.92157 2.25 3.75V14.25C2.25 15.0784 2.92157 15.75 3.75 15.75H7.5C7.91421 15.75 8.25 15.4142 8.25 15Z"
        fill="currentColor"
      />
      <path
        d="M16.2852 9.52541C16.3547 9.45465 16.4073 9.37354 16.4431 9.28709C16.4795 9.19931 16.4997 9.10312 16.5 9.00225L16.5 9L16.5 8.99775C16.4994 8.80656 16.4262 8.61554 16.2803 8.46967L13.2803 5.46967C12.9874 5.17678 12.5126 5.17678 12.2197 5.46967C11.9268 5.76256 11.9268 6.23744 12.2197 6.53033L13.9393 8.25H6.75C6.33579 8.25 6 8.58579 6 9C6 9.41421 6.33579 9.75 6.75 9.75H13.9393L12.2197 11.4697C11.9268 11.7626 11.9268 12.2374 12.2197 12.5303C12.5126 12.8232 12.9874 12.8232 13.2803 12.5303L16.2798 9.53086L16.2852 9.52541Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Language = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="18"
      height="18"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      class=""
    >
      <g>
        <path
          d="m195.708 268.059-30-150.001A14.999 14.999 0 0 0 151 106h-30a14.999 14.999 0 0 0-14.708 12.058l-30 150c-1.625 8.124 3.644 16.026 11.767 17.65 8.123 1.625 16.026-3.644 17.65-11.767L115.297 226h41.406l9.588 47.942c1.625 8.127 9.531 13.392 17.65 11.767 8.123-1.625 13.392-9.527 11.767-17.65zM121.297 196l12-60h5.406l12 60h-29.406zM436 226h-45v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-45c-8.284 0-15 6.716-15 15s6.716 15 15 15h3.63c8.547 27.612 21.415 48.806 35.575 65.79-11.525 10.542-23.187 19.187-33.575 27.497-6.469 5.175-7.518 14.614-2.342 21.083 5.178 6.472 14.618 7.515 21.083 2.342 10.446-8.357 22.967-17.644 35.629-29.264 12.671 11.628 25.215 20.932 35.629 29.264 6.469 5.176 15.909 4.126 21.083-2.342 5.175-6.469 4.126-15.909-2.342-21.083-10.361-8.291-22.038-16.945-33.575-27.497 14.16-16.984 27.028-38.178 35.575-65.79H436c8.284 0 15-6.716 15-15s-6.716-15-15-15zm-60 73.745c-9.575-12.02-18.189-26.367-24.683-43.845h49.365c-6.493 17.478-15.107 31.825-24.682 43.845z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
        ></path>
        <path
          d="M467 91H250.599l-6.43-51.582C241.36 16.946 222.164 0 199.517 0H45C20.187 0 0 20.187 0 45v331c0 24.813 20.187 45 45 45h126.483l6.348 51.582c2.804 22.427 22 39.418 44.653 39.418H467c24.813 0 45-20.187 45-45V136c0-24.813-20.187-45-45-45zM45 391c-8.271 0-15-6.729-15-15V45c0-8.271 6.729-15 15-15h154.517c7.549 0 13.948 5.648 14.883 13.134L257.764 391H45zm161.724 70.75L201.709 421h40.244l-35.229 40.75zM482 467c0 8.271-6.729 15-15 15H228.874l57.104-66.053a14.976 14.976 0 0 0 3.629-12.024L254.339 121H467c8.271 0 15 6.729 15 15v331z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
        ></path>
      </g>
    </svg>
  );
};
